import react from "react"
import "./Contact.css"
import Aos from "aos"
import img1 from "./images/RanjanPrasad.jpeg"
import img2 from "./images/ Ayushiyadav.jpeg"
import img3 from "./images/Chakkaphanisimha.jpeg"
import "aos/dist/aos.css"

const Contact = () => {
  react.useEffect(() => {
    Aos.init({ duration: 1200 })
  }, [])
  return (
    <section className="contact" data-aos="fade-up">
      <h1 data-aos="fade-up">Contact</h1>
      <div className="members">
        <div className="member joinSec" data-aos="fade-up">
          <img src={img1} alt=" Ranjan Prasad" />
          <div className="memberName">
            <span>Ranjan</span>
            <span className="memberNameSpace">&nbsp;</span>
            <span>Prasad</span>
          </div>
          <div className="status">
            <span>Joint</span>
            <span className="memberNameSpace">&nbsp;</span>
            <span>Secretary</span>
          </div>
          <div>6291097714</div>
        </div>
        <div className="member" data-aos="fade-up">
          <img src={img2} alt="Ayushi yadav" />
          <div className="memberName">
            <span>Ayushi</span>
            <span className="memberNameSpace">&nbsp;</span>
            <span>yadav</span>
          </div>
          <div className="status">
            <span>Secretary</span>
          </div>
          <div>8090097601</div>
        </div>
        <div className="member joinSec" data-aos="fade-up">
          <img src={img3} alt="Chakka Phani Simha" />
          <div className="memberName">
            <span>Chakka Phani </span>
            <span className="memberNameSpace">&nbsp;</span>
            <span>Simha</span>
          </div>
          <div className="status">
            <span>Joint</span>
            <span className="memberNameSpace">&nbsp;</span>
            <span>Secretary</span>
          </div>
          <div>9949628592</div>
        </div>
      </div>
    </section>
  )
}

export default Contact
